// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { View, StyleSheet } from "react-native";

// hocs
import withMedia from "../../hocs/withMedia";

// components
import BaseComponent from "../BaseComponent";
import Text from "../Text";
import Stack from "../Stack";
import Rate from "../Rate";

// constants
import { STAR_COUNT } from "../../constants/rate";

type PropsType = {
  matches?: boolean;
  reviews: number;
  rate: number;
};

const getStyles = ({ matches }) =>
  StyleSheet.create({
    review: {
      flexDirection: "row",
      alignItems: "center",
    },
    reviewWrapper: {
      fontSize: (matches ? "1.625em" : "1em") as any,
    },
    reviewCount: {
      fontSize: "1em" as any,
    },
    rate: {
      flexDirection: "row",
      alignItems: "center",
    },
    rightBorder: {
      flex: 1,
      borderStyle: "solid",
      borderColor: "currentColor",
      borderTopWidth: 2,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeftWidth: 0,
    },
    text: {
      fontSize: "0.625em" as any,
    },
  });

const Reviews: React.FunctionComponent<PropsType> = (props) => {
  const { rate, reviews, matches } = props;
  const intl = useIntl();

  const styles = getStyles({ matches });

  return (
    <BaseComponent
      childrenStyle={styles.review}
      wrapperStyle={styles.reviewWrapper}
    >
      <Text style={styles.reviewCount}>
        {intl.formatMessage(
          {
            defaultMessage:
              "{reviews, number} {reviews, plural, one {avis client} other {avis clients}}",
          },
          { reviews }
        )}
      </Text>
      <Stack marginRight={0.625} />
      <View style={styles.rate}>
        <Rate rate={rate} />

        <Stack marginRight={0.3125} />

        <Text style={styles.text}>
          {intl.formatMessage(
            {
              defaultMessage: "({rate, number} / {maxRate, number})",
            },
            { rate, maxRate: STAR_COUNT }
          )}
        </Text>
      </View>
      <Stack marginRight={0.625} />
      {matches && (
        <View
          style={styles.rightBorder}
          importantForAccessibility="no-hide-descendants"
          accessible={false}
        />
      )}
    </BaseComponent>
  );
};

export default withMedia({ query: { minWidth: 490 } })(Reviews);
